// @flow

import { declareAction, declareAtom } from '@reatom/core'
import axios from 'axios'
import * as common from '@bfg/common'
import {
  PaymentAtom,
  SetPaymentProcessor,
  SuccessfulPayment,
  UnSuccessfulPayment
} from '@bfg/atoms/Payment'
import { AppConfigAtom } from '@bfg/atoms/AppConfig'
import { PaywallVariantAtom } from '@bfg/atoms/PaywallVariant'
import { gtagEventNew } from '@bfg/utils/gtag'
import { UtmAnalytics } from '@bfg/atoms/UtmAnalytics'
import { SubscriberAtom, SubscriberLoaded } from '@bfg/atoms/Subscriber'
import { NREndPaymentProcess, NRError, NRSubscribed, NRSuccess } from '@bfg/atoms/NewRelic'
import { ErrorLog } from '@bfg/atoms/Debug'
import { SkipStepExperimentEnum } from '@bfg/enums/SkipStepExperimentEnum'

export const CheckApplePaySupport = declareAction(
  'checkApplePaySupportAction',
  (payload, store) => {
    store.dispatch(StoreAdditionalData({ ...payload }))
    if (window.ApplePaySession) {
      const canMakePayments = window.ApplePaySession.canMakePayments()
      if (canMakePayments) {
        store.dispatch(ApplePaySupportEnabled())
        const data = new FormData()
        data.append('paymentTypeId', payload.paymentTypeId)
        axios.post(
          `${common.api}/braintree/client`,
          data
        )
          .then(response => {
            if (response.status === 200) {
              braintree.client
                .create({
                  authorization: response.data.clientToken
                })
                .then(function (clientInstance) {
                  return braintree.applePay.create({
                    client: clientInstance
                  })
                })
                .then(function (applePayInstance) {
                  store.dispatch(StoreBraintreeAppleSession(applePayInstance))
                  axios.post(
                    `${common.api}/payment-request/braintree/apple/subscription`,
                    data
                  ) //subscription payment request
                    .then(response => {
                      if (response.status === 200) {
                        if (applePayInstance) {
                          const paymentRequestObject = response.data
                          const paymentRequest = applePayInstance.createPaymentRequest(paymentRequestObject)
                          store.dispatch(StorePaymentRequest(paymentRequest))
                        }
                      } else {
                      }
                    })
                    .catch(console.error)
                })
                .catch(function (err) {
                  // Handle error
                })
            }
          })
          .catch(function (err) {
          })

      }
    }
  }
)

export const ShowApplePaymentRequest = declareAction(
  'showApplePayRequestAction',
  (payload, store) => {
    // (async () => {
    //   try {
    const state = store.getState(ApplePaymentAtom)
    const paymentRequestObject = state.paymentRequest
    const applePayInstance = state.braintreeAppleSession
    const { paymentTypeId: paymentTypeId, experiments: experiments } = state.additionalData
    const appleSession = new ApplePaySession(3, paymentRequestObject)
    if (appleSession !== null) {
      appleSession.onvalidatemerchant = (event) => {
        applePayInstance.performValidation({
          validationURL: event.validationURL,
          displayName: 'BabyFaceGenerator'
        }, function (err, merchantSession) {
          if (err) {
            // You should show an error to the user, e.g. 'Apple Pay failed to load.'
            return
          }
          appleSession.completeMerchantValidation(merchantSession)
        })
        //   store.dispatch(ValidateMerchantAction(event.validationURL))
      }
      appleSession.onpaymentauthorized = (event) => {
        const email = event.payment.shippingContact.emailAddress
        applePayInstance.tokenize({
          token: event.payment.token
        }, function (tokenizeErr, payloadToken) {
          if (tokenizeErr) {
            console.error('Error tokenizing Apple Pay:', tokenizeErr)
            appleSession.completePayment(ApplePaySession.STATUS_FAILURE)
            return
          }
          // return
          store.dispatch(ProcessPayment({
            paymentData: { token: payloadToken.nonce, email: email },
            paymentTypeId: paymentTypeId,
            experiments: experiments
          }))
        })

        // store.dispatch(ProcessPayment(event.payment))
      }
      store.dispatch(StoreSession(appleSession))
      appleSession.begin()
    } else {
    }
    //   } catch (e) {
    //   }
    // })()
  }
)

const ApplePaySupportEnabled = declareAction('applePaySupportedAction')
const StorePaymentRequest = declareAction('storePaymentRequestAction')
const StoreSession = declareAction('storeSessionAction')
const StoreAdditionalData = declareAction('storeAdditionalDataAction')
const StoreBraintreeAppleSession = declareAction('storeBraintreeAppleSessionAction')
// const ValidateMerchantAction = declareAction(
//   'validateMerchantAction',
//   (payload, store) => {
//     const state = store.getState(ApplePaymentAtom)
//     const session = state.session
//     const form = new FormData()
//     form.append('validationUrl', payload)
//     axios.post(
//       `${common.api}/validate-merchant/apple/braintree`,
//       form,
//       { headers: { 'Content-Type': 'multipart/form-data' } }
//     )
//       .then(response => {
//           if (response.status === 200) {
//             session.completeMerchantValidation(JSON.parse(response.data.token))
//           }
//         }
//       )
//       .catch(console.error)
//   }
// )

const ProcessPayment = declareAction(
  'processPaymentAction',
  (payload, store) => {
    const appState = store.getState(AppConfigAtom)
    const utmState = store.getState(UtmAnalytics)
    const paymentState = store.getState(PaymentAtom)
    const state = store.getState(ApplePaymentAtom)
    const session = state.session
    const subscriberState = store.getState(SubscriberAtom)

    const skipStepExperiment = payload.experiments.skipStepExperiment
    const version = payload.experiments.generatorExperiment

    const stepSkipExperimentData = {
      experimentName: 'stepSkip',
      experimentValue: skipStepExperiment === SkipStepExperimentEnum.skip
        ? 'flow-3-step'
        : 'flow-4-step',
    }

    const data = {
      token: payload.paymentData.token,
      paymentTypeId: payload.paymentTypeId,
      processor: 'APPLE',
      gateway: paymentState.gateway,
      utmSource: utmState.utmSource,
      utmMedium: utmState.utmMedium,
      utmCampaign: utmState.utmCampaign,
      version: version,
      email: payload.paymentData.email,
      experiments: [
        stepSkipExperimentData
      ],
      gclid: utmState.gclid,
      paywallVariant: store.getState(PaywallVariantAtom).variant,
    }
    localStorage.setItem('payeremail', payload.paymentData.email)
    // const paymentToken = b64EncodeUnicode(JSON.stringify(payload.token));
    // const paymentToken = Base64.encode(JSON.stringify(payload.token));
    axios.post(
      `${common.api}/${appState.gateway.aPay}/subscriber/${appState.fingerprint}/subscribe-monthly/apple`, //subscription
      data
    )
      .then(response => {
          store.dispatch(NREndPaymentProcess())
          if (response.data.state === 'active') {
            session.completePayment(ApplePaySession.STATUS_SUCCESS)
            const newSubscription = { ...response.data }
            delete newSubscription.subscriber
            const newSubscriptionsList = [...subscriberState.subscriber.subscriptions]
            newSubscriptionsList.push(newSubscription)
            store.dispatch(SubscriberLoaded({ ...subscriberState.subscriber, subscriptions: newSubscriptionsList }))
            store.dispatch(SetPaymentProcessor('APPLE'))
            store.dispatch(SuccessfulPayment({ date: response.data.expireDate, experiment: skipStepExperiment }))
            const eventShort = 'applepay_subscription_monthly_new'
            gtagEventNew(eventShort)
            if (window.fbq && typeof window.fbq === 'function') {
              window.fbq('track', 'BFGconversion')
            }
            if (window.ttq) {
              window.ttq.track('Subscribe')
              window.ttq.track('BFGconversion')
            }
            store.dispatch(NRSubscribed(NRSuccess))
          } else {
            const container = document.getElementById('apple-pay-button')
            if (container) {
              container.style.display = 'initial'
            }
            session.completePayment(ApplePaySession.STATUS_FAILURE)
            store.dispatch(UnSuccessfulPayment())
            store.dispatch(NRSubscribed(NRError))
          }
        }
      )
      .catch(e => {
        console.error(e)
        store.dispatch(ErrorLog(e))
      })
  }
)

const b64EncodeUnicode = str => btoa(
  encodeURIComponent(str).replace(
    /%([0-9A-F]{2})/g,
    function toSolidBytes (match, p1) {
      return String.fromCharCode('0x' + p1)
    }
  )
)

export const ApplePaymentAtom = declareAtom(
  'applePaymentAtom',
  {
    applePayEnabled: false,
    paymentRequest: null,
    session: null,
    braintreeAppleSession: null,
    additionalData: {},
  },
  on => [
    on(ApplePaySupportEnabled, (state, payload) => {
      return { ...state, applePayEnabled: true }
    }),
    on(StorePaymentRequest, (state, payload) => {
      return { ...state, paymentRequest: payload }
    }),
    on(StoreSession, (state, payload) => {
      return { ...state, session: payload }
    }),
    on(StoreBraintreeAppleSession, (state, payload) => {
      return { ...state, braintreeAppleSession: payload }
    }),
    on(StoreAdditionalData, (state, payload) => {
      return { ...state, additionalData: { ...state.additionalData, ...payload } }
    })
  ]
)